import {
  categorizeRegisterFilteredWord,
  REGISTER_FILTERED_STAT_KEYS,
} from "./registerFilteredStats";

function parseCaptureDate(dateStr) {
  const match = String(dateStr || "")
    .trim()
    .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return null;
  const time = new Date(
    Number(match[3]),
    Number(match[2]) - 1,
    Number(match[1])
  ).getTime();
  return Number.isFinite(time) ? time : null;
}

function formatPercent(count, total) {
  if (total <= 0) return "0 %";
  const value = Math.round((count / total) * 1000) / 10;
  return `${value.toLocaleString("fr-FR", {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 1,
    maximumFractionDigits: 1,
  })} %`;
}

export function computeGroupementStats(entries = []) {
  const words = entries.filter((entry) => entry?.mot);
  const total = words.length;
  let mastered = 0;
  let never = 0;
  let review = 0;
  let latestTime = null;
  let latestLabel = "";

  for (const entry of words) {
    const category = categorizeRegisterFilteredWord(entry);
    if (category === REGISTER_FILTERED_STAT_KEYS.NEVER) never += 1;
    else if (category === REGISTER_FILTERED_STAT_KEYS.MASTERED) mastered += 1;
    else review += 1;

    const time = parseCaptureDate(entry.date);
    if (time != null && (latestTime == null || time > latestTime)) {
      latestTime = time;
      latestLabel = String(entry.date).trim();
    }
  }

  return {
    total,
    mastered: {
      count: mastered,
      percentLabel: formatPercent(mastered, total),
    },
    review: {
      count: review,
      percentLabel: formatPercent(review, total),
    },
    never: {
      count: never,
      percentLabel: formatPercent(never, total),
    },
    latestCapture: latestLabel || null,
  };
}

export function normalizeGroupementWord(item) {
  if (!item) return null;
  if (typeof item === "string") {
    return { mot: item, definition: "", date: "", paquet: null, stats: {} };
  }
  if (!item.mot) return null;
  return item;
}
